import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import {
  clearSectionSaveErrors,
  registerSection,
  toggleSectionOpen,
  unregisterSection
} from "utils/sectionManagement/actions";
import {isFunction} from 'utils/DBUtils';
import catchErrors from './catchErrors';

const resourceSection = ({reducerKey, openSection, sectionGroup, sectionKey, section, sectionIndex, formProxy}, SectionComponent) => {
    const groupKey = sectionGroup || sectionKey || "global";
    const mapStateToProps = (state, ownProps) => {
        const group = state[reducerKey].sectionsActiveGroups[groupKey] || [];
        const accordion = group.find(section => section.key === sectionKey) || {};
        const fields = accordion.fields || [];

        const showSection = isFunction(section.showSection) ? section.showSection(formProxy) : true;

        let props = {
            active: group ? (accordion.open || false) : false, // explicit false if null or undefined
            hasFields: Boolean(fields.length),
            showSection,
            openSection: sectionKey === openSection
        };

        if (section.props) {
          // Since the function reference to 'getCustomSectionHeader' doesn't change,
          // just passing it directly down directly will not cause a re-render
          // So we pass the result of the 'getCustomSectionHeader' function which can change
          if (section.props.getCustomSectionHeader) {
            props.header = section.props.getCustomSectionHeader(formProxy.currentResource, sectionIndex);
          } else if (section.props.getHeader) {
            props.header = section.props.getHeader(formProxy.currentResource);
          }
        }

        if ( section.deleteable || section.canDelete ) {
          props.deletable = section.deletable && (!section.canDelete || section.canDelete(formProxy));
        }

        // Figure out if there are any errors in this section
        if (section.fields && section.fields.length > 0) {
            let hasError = false;
            let errorKeys = Object.keys(state.resources.saveErrors);
            for (let key of errorKeys) {
                let error = state.resources.saveErrors[key];
                // section has an error if an save error contains this sections key in its path
                if (error.sectionKeyPath && error.sectionKeyPath.indexOf(sectionKey) > -1) {
                    hasError = true;
                    break;
                }
            }
            props.hasError = hasError;
        }

        props.animate = ownProps.animate;

        return props;
    };

    const mapDispatchToProps = (dispatch) => {
        return {
            toggleOpen: shouldScroll => dispatch(toggleSectionOpen(sectionGroup, sectionKey, shouldScroll))
        };
    };

    const ConnectedSection = compose(
        catchErrors,
        connect(mapStateToProps, mapDispatchToProps)
    )(SectionComponent);

    return ConnectedSection;
};

export default resourceSection;



// WEBPACK FOOTER //
// ./public/hoc/ResourceSection.jsx